import React from 'react';
import { ScrollReveal } from '../ui/ScrollReveal';
import { ZapIcon, RouteIcon, TargetIcon } from 'lucide-react';
export function SolutionSection() {
  return <section className="w-full py-20 md:py-32 px-5" data-id="element-452">
      <div className="max-w-3xl mx-auto" data-id="element-453">
        {/* Formula headline */}
        <ScrollReveal data-id="element-454">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white leading-tight mb-6" data-id="element-455">
            La solución: la <span className="text-accent" data-id="element-456">Fórmula 1–3–1</span>
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={0.1} data-id="element-457">
          <p className="text-lg md:text-xl text-neutral-300 leading-relaxed mb-12" data-id="element-458">
            No necesitas "talento especial".{' '}
            <span className="text-white font-bold" data-id="element-459">
              Necesitas un sistema para fabricar ganchos que se sientan
              naturales en tu voz.
            </span>
          </p>
        </ScrollReveal>

        {/* Formula visual */}
        <ScrollReveal delay={0.15} data-id="element-460">
          <div className="relative" data-id="element-461">
            {/* Connecting line */}
            <div className="absolute left-[27px] md:left-[31px] top-0 bottom-0 w-px bg-gradient-to-b from-accent via-accent-light to-accent hidden md:block" data-id="element-462" />

            <div className="space-y-6" data-id="element-463">
              {/* 1 Golpe */}
              <div className="relative flex gap-5 md:gap-6 items-start" data-id="element-464">
                <div className="relative z-10 flex-shrink-0 w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-accent/15 border border-accent/30 flex items-center justify-center" data-id="element-465">
                  <ZapIcon className="w-6 h-6 md:w-7 md:h-7 text-accent" data-id="element-466" />
                </div>
                <div className="pt-1" data-id="element-467">
                  <div className="flex items-baseline gap-3 mb-2" data-id="element-468">
                    <span className="text-3xl md:text-4xl font-extrabold text-accent" data-id="element-469">
                      1
                    </span>
                    <span className="text-xl md:text-2xl font-bold text-white" data-id="element-470">
                      Golpe
                    </span>
                  </div>
                  <p className="text-neutral-300 text-lg leading-relaxed" data-id="element-471">
                    Tensión inmediata{' '}
                    <span className="text-neutral-500" data-id="element-472">
                      (sin gritar, sin cringe).
                    </span>
                  </p>
                </div>
              </div>

              {/* 3 Rutas */}
              <div className="relative flex gap-5 md:gap-6 items-start" data-id="element-473">
                <div className="relative z-10 flex-shrink-0 w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-accent-light/10 border border-accent-light/30 flex items-center justify-center" data-id="element-474">
                  <RouteIcon className="w-6 h-6 md:w-7 md:h-7 text-accent-light" data-id="element-475" />
                </div>
                <div className="pt-1" data-id="element-476">
                  <div className="flex items-baseline gap-3 mb-2" data-id="element-477">
                    <span className="text-3xl md:text-4xl font-extrabold text-accent-light" data-id="element-478">
                      3
                    </span>
                    <span className="text-xl md:text-2xl font-bold text-white" data-id="element-479">
                      Rutas
                    </span>
                  </div>
                  <p className="text-neutral-300 text-lg leading-relaxed" data-id="element-480">
                    Eliges una:{' '}
                    <span className="text-white font-semibold" data-id="element-481">Curiosidad</span>{' '}
                    /{' '}
                    <span className="text-white font-semibold" data-id="element-482">Beneficio</span>{' '}
                    /{' '}
                    <span className="text-white font-semibold" data-id="element-483">Contraste</span>.
                  </p>
                </div>
              </div>

              {/* 1 Remate */}
              <div className="relative flex gap-5 md:gap-6 items-start" data-id="element-484">
                <div className="relative z-10 flex-shrink-0 w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-accent/15 border border-accent/30 flex items-center justify-center" data-id="element-485">
                  <TargetIcon className="w-6 h-6 md:w-7 md:h-7 text-accent" data-id="element-486" />
                </div>
                <div className="pt-1" data-id="element-487">
                  <div className="flex items-baseline gap-3 mb-2" data-id="element-488">
                    <span className="text-3xl md:text-4xl font-extrabold text-accent" data-id="element-489">
                      1
                    </span>
                    <span className="text-xl md:text-2xl font-bold text-white" data-id="element-490">
                      Remate
                    </span>
                  </div>
                  <p className="text-neutral-300 text-lg leading-relaxed" data-id="element-491">
                    Micro-promesa para empujar al cuerpo del video.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={0.2} data-id="element-492">
          <p className="mt-10 text-lg md:text-xl text-neutral-300 leading-relaxed" data-id="element-493">
            Esto convierte el gancho en algo{' '}
            <span className="text-white font-bold" data-id="element-494">repetible</span>, no algo
            "inspiracional".
          </p>
        </ScrollReveal>
      </div>
    </section>;
}